import styled from 'styled-components'

export const FilterOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1060;
    background: var(--background-app);
    overflow-y: auto;
    display: flex;
    justify-content: center;
`

export const FilterPanel = styled.div`
    width: 100%;
    max-width: 414px;
    min-height: 100%;
    background: var(--background-app);
    padding: 48px 32px 32px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`

export const FilterHeading = styled.h2`
    margin: 0;
    color: var(--title-color);
    font-size: 24px;
    font-weight: 600;
    line-height: 1.5;
`

export const FilterSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const SectionTitle = styled.h3`
    margin: 0;
    color: var(--title-color);
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: -0.8px;
`

export const FieldInput = styled.input`
    width: 100%;
    height: 54px;
    border-radius: 4px;
    border: 1px solid rgba(133, 163, 167, 0.33);
    background: var(--background-app);
    color: var(--text-color);
    padding: 16px;
    font-size: 14px;
    line-height: 1;
    letter-spacing: -0.8px;
    outline: none;

    &::placeholder {
        color: var(--text-color);
        opacity: 1;
    }

    &:focus {
        border-color: rgba(133, 163, 167, 0.8);
    }
`

export const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
`

export const StarsOption = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`

export const StarsCheckbox = styled.input`
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid var(--primary-color);
    border-radius: 4px;
    background: var(--background-app);
    margin: 0;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:checked {
        background: var(--primary-color);
    }

    &:checked::after {
        content: "";
        position: absolute;
        width: 5px;
        height: 10px;
        border: solid var(--button-primary-text);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        margin-bottom: 2px;
    }
`

export const StyledLabel = styled.label`
    cursor: pointer;
    font-family: var(--font-family-base);
    color: var(--text-color);
`

export const StarsLine = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        color: var(--primary-color);
        width: 22px;
        height: 22px;
    }
`

export const RadioLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-family: var(--font-family-base);

    &:not(:last-child) {
        margin-bottom: 16px;
    }

    span {
        color: var(--text-color);
        font-size: 14px;
        line-height: 1;
        letter-spacing: -0.8px;
    }
`

export const RadioInput = styled.input`
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid var(--primary-color);
    background: var(--background-app);
    margin: 0;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:checked::after {
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--primary-color);
    }

    &:checked + span {
        color: var(--primary-color);
    }
`

export const FilterActions = styled.div`
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 8px;
`

export const ActionButtonPrimary = styled.button`
    width: 100%;
    height: 42px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    background: var(--primary-color);
    color: var(--button-primary-text);
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    cursor: pointer;
`

export const ActionButtonSecondary = styled.button`
    width: 100%;
    height: 42px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    background: transparent;
    color: var(--primary-color);
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    cursor: pointer;
`
